import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.array.map";
import "core-js/modules/es.object.get-prototype-of";
import "core-js/modules/es.object.set-prototype-of";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Carousel from 'nuka-carousel';
import { FormattedMessage } from 'react-intl';
import { ga } from 'helpers/multitrack';
import trackDwell from 'decorators/TrackDwell/TrackDwell';
import media from 'decorators/Media/Media';
import { Pagination, CarouselNext, CarouselPrev } from '../../../Carousel/Controls';
import { testimonialsData as data } from './testimonialsData';
export var TestimonialsUnwrapped =
/*#__PURE__*/
function (_Component) {
  _inherits(TestimonialsUnwrapped, _Component);

  function TestimonialsUnwrapped() {
    _classCallCheck(this, TestimonialsUnwrapped);

    return _possibleConstructorReturn(this, _getPrototypeOf(TestimonialsUnwrapped).apply(this, arguments));
  }

  _createClass(TestimonialsUnwrapped, [{
    key: "onDwell",
    value: function onDwell() {
      ga('Testimonials Module', 'Viewed testimonials module', '', 0, {
        nonInteraction: true
      });
    }
  }, {
    key: "render",
    value: function render() {
      var testimonials = data;
      var _this$props = this.props,
          mediaQueryMd = _this$props.mediaQueryMd,
          backgroundColor = _this$props.backgroundColor;
      return React.createElement("div", {
        className: "testimonials bg--".concat(backgroundColor || 'white')
      }, React.createElement("div", null, React.createElement("h2", null, React.createElement(FormattedMessage, {
        id: "testimonials.header",
        defaultMessage: "What members have to say"
      })), React.createElement(Carousel, {
        decorators: mediaQueryMd ? [{
          component: CarouselPrev,
          position: 'CenterLeft'
        }, {
          component: CarouselNext,
          position: 'CenterRight'
        }] : [{
          component: Pagination,
          position: 'BottomCenter'
        }],
        className: "carousel--testimonials",
        cellAlign: "left",
        edgeEasing: "easeOut",
        speed: 150,
        slidesToShow: 1,
        slidesToScroll: 1
      }, testimonials.map(function (testimonial) {
        return React.createElement("div", {
          className: "testimonials__item",
          key: testimonial.source
        }, React.createElement("blockquote", null, testimonial.quote), React.createElement("div", {
          className: "testimonials__item__source"
        }, React.createElement("span", null, React.createElement("h3", null, testimonial.source), React.createElement("p", null, testimonial.location))));
      }))));
    }
  }]);

  return TestimonialsUnwrapped;
}(Component);
TestimonialsUnwrapped.propTypes = {
  mediaQueryMd: PropTypes.bool,
  backgroundColor: PropTypes.oneOf(['white', 'light'])
};
export var Testimonials = media(trackDwell(TestimonialsUnwrapped));